import './style/index.scss';
import * as serviceWorker from './serviceWorker';
import { renderApp } from './renderApp';
import { renderMetaTags } from 'utils/metaUtils';

renderApp();
renderMetaTags();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
